export default function WhatIsSection() {
  return (
    <section id="what-is" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            Was ist ein <strong>OOPBUY Spreadsheet</strong>?
          </h2>
          <div className="w-12 h-0.5 bg-primary-400 mx-auto mb-6"></div>
          <p className="text-sm md:text-base text-foreground-600 max-w-3xl mx-auto leading-relaxed">
            Ein <strong>OOPBUY Spreadsheet</strong> ist eine organisierte Produktübersicht, die Nutzern hilft,
            interessante Artikel schneller zu entdecken und verschiedene Produkte einfacher zu vergleichen.
            Im Gegensatz zur manuellen Suche in Online-Shops bietet ein strukturiertes Spreadsheet klare
            Kategorien, detaillierte Produktinformationen und eine bessere Übersicht über das gesamte
            Angebot. Deutsche Käufer profitieren besonders von dieser strukturierten Herangehensweise,
            da sie Zeit spart und den Einkaufsprozess erheblich vereinfacht.
          </p>
        </div>
      </div>
    </section>
  );
}